export enum ExerciseType {
  EDITING = "EDITING",
  NAVIGATION = "NAVIGATION",
  BOTH = "BOTH",
}
